import NotificationOverloadSolution from '../posts/NotificationOverloadSolution';
import DigitalWellnessTrends2024 from '../posts/DigitalWellnessTrends2024';
import BuildingFocusHabits from '../posts/BuildingFocusHabits';

export interface BlogPost {
  id: string;
  title: string;
  excerpt: string;
  author: string;
  date: string;
  readTime: string;
  tags: string[];
  featured: boolean;
  component: React.ComponentType;
}

export const blogPosts: BlogPost[] = [
  {
    id: "notification-overload-solution",
    title: "The Hidden Cost of Notification Overload",
    excerpt: "Discover how constant notifications are silently draining your productivity and learn how batching can help you reclaim your focus.",
    author: "Sera Team",
    date: "2026-01-15",
    readTime: "5 min read",
    tags: ["productivity", "notifications", "focus"],
    featured: true,
    component: NotificationOverloadSolution
  },
  {
    id: "digital-wellness-trends-2024",
    title: "Digital Wellness Trends for 2024",
    excerpt: "Explore the latest trends in digital wellness and how they're shaping our relationship with technology.",
    author: "Sera Team",
    date: "2024-01-10",
    readTime: "7 min read",
    tags: ["digital wellness", "trends", "technology"],
    featured: true,
    component: DigitalWellnessTrends2024
  },
  {
    id: "building-focus-habits",
    title: "Building Sustainable Focus Habits",
    excerpt: "Learn practical strategies for developing and maintaining focus habits that actually stick in our distracted world.",
    author: "Sera Team",
    date: "2024-01-05",
    readTime: "6 min read",
    tags: ["habits", "focus", "productivity"],
    featured: false,
    component: BuildingFocusHabits
  }
];

// Helper function to check if a post is published (not in the future)
const isPublished = (post: BlogPost): boolean => {
  const postDate = new Date(post.date);
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Reset time to start of day for accurate comparison
  return postDate <= today;
};

// Get all published posts
export const getPublishedPosts = (): BlogPost[] => {
  return blogPosts.filter(isPublished);
};

export const getFeaturedPosts = (): BlogPost[] => {
  return blogPosts.filter(post => post.featured && isPublished(post));
};

export const getPostById = (id: string): BlogPost | undefined => {
  const post = blogPosts.find(post => post.id === id);
  return post && isPublished(post) ? post : undefined;
};

export const getPostsByTag = (tag: string): BlogPost[] => {
  return blogPosts.filter(post => post.tags.includes(tag) && isPublished(post));
};
